import React from "react"
import styled from "styled-components"

import { theme } from "Theme"
import mixins from "Styles"

const Wrapper = styled.div`
  color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  min-height: ${(props) => (props.big ? "400px;" : "100px;")};
  background-color: ${(props) => (props.dark ? theme.colors.background.black : theme.colors.background.light)};
  color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  border-color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column-reverse;

  align-items: center;
  margin: 0 auto;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
    margin: 0 auto 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .gatsby-image-wrapper {
    position: initial !important;
  }
`

export const Content = styled.div`
  // ${mixins.backgroundBefore};
  display: block;
  padding: 1rem 2rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  max-width: ${theme.layout.base};

  @media (min-width: ${theme.breakpoints.s}) {
    padding: 1rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const LogosStrip = ({ big, dark, children }) => {
  return (
    <>
      <Wrapper dark={dark ? 1 : undefined} big={big}>
        <Content dark={dark ? 1 : undefined}>{children && children}</Content>
      </Wrapper>
    </>
  )
}

export default LogosStrip
